export default "__VITE_ASSET__467ea600__"